import React from "react";
import Dropzone from "react-dropzone";
import axios from 'axios'
import UIkit from 'uikit'
import { SERVER_URL } from '../../utils/helpers/constanteData'
import { updateBeneficiaire, getPicture } from "../../utils/ApiRest/backendMembers";
import avatar_img from "../../utils/assets/images/avatar_user.png"
import icon_alert_avatar from "../../utils/assets/images/icon-alert-avatar.png"

class AvatarBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filePreview: null,
      loading: false,
      empty: true,
    };
  }
  onDropFile = (files) => {
    let formData = new FormData();
    formData.append('uri', files[0])
    const config = {
      headers: { 'content-type': 'multipart/form-data' }
    }
    const url = SERVER_URL+'/uploads';
    this.setState({loading: true, empty: false})
    axios.post(url, formData, config)
      .then((response) => {
          return updateBeneficiaire(this.props.beneficiaireData._id, {picture: response.data.id})
      }).then((response) => {
          return getPicture(response.picture)
      }).then((response) => {
        this.setState({filePreview: response.uri, loading: false})
      })
      .catch((error) => {
          this.showError()
      });
  }
  showError = () => {
    UIkit.notification({
      message: "<i class='fa fa-times-circle aps-section-notification-box-icon'></i> Erreur lors de l'enregistrement de la photo",
      status: 'danger',
      pos: 'top-center',
    })
  }
  componentDidMount() {
    if (this.props.beneficiaireData.picture) {
      this.getProfile(this.props.beneficiaireData.picture)
    }
  }
  getProfile = (id) => {
    this.setState({loading: true, empty: false})
    getPicture(id).then((response) => {
      this.setState({filePreview: response.uri, loading: false})
    }).catch((error) => {
      this.showError()
  });
  }
  render() {
    let avatar;
    if (this.state.empty) {
      avatar = <Empty />
    } else if (this.state.loading) {
      avatar = <Loading />
    } else {
      avatar = <Content image={this.state.filePreview} />
    }
    const {beneficiaireData} = this.props
    return (
      <div className="aps-questionnaire-identity-grid uk-grid" data-uk-grid>
        <div className="uk-width-1-2 aps-questionnaire-identity-grid-first uk-first-column">
          <div>
            <span>Nom : </span>
            <strong className="uk-text-bold">{beneficiaireData.firstname}</strong>
          </div>
          <div>
            <span>Prénom : </span>
            <strong className="uk-text-bold">{beneficiaireData.lastname}</strong>
          </div>
          <div>
            <span>Date de naissance : </span>
            <strong>{beneficiaireData.birthday}</strong>
          </div>
          <div>
            <span>Sexe : </span>
            <strong className="uk-text-bold">{beneficiaireData.sex}</strong>
          </div>
          <div>
            <span>Taille : </span>
            <strong className="uk-text-bold">{beneficiaireData.taille} cm</strong>
          </div>
          <div>
            <span>Poids : </span>
            <strong className="uk-text-bold">{beneficiaireData.poids} kg</strong>
          </div>
        </div>

        <div className="uk-width-1-2 aps-questionnaire-identity-grid-second">
          <Dropzone className="uk-text-center" style={{border: 'none'}} onDrop={this.onDropFile} multiple={false}>
            {avatar}
          </Dropzone>
          <div className="uk-text-center aps-questionnaire-identity-photo-av-container">
            <img className="aps-icon-alert-avatar" src={icon_alert_avatar} alt="icon" />
            <span className="aps-questionnaire-identity-photo-av">
              La photo n’est pas indispensable à cette étape, mais elle sera demandée pour l’émission de votre carte d’assuré.
            </span>
          </div>
        </div>
      </div>
    );
  }
}
const Empty = () => {
  return (
  <div
    className="aps-questionnaire-identity-photo-container uk-form-custom"
    data-uk-form-custom
  >
    <img
      className="aps-questionnaire-identity-photo-picker"
      src={avatar_img}
      alt="avatar"
    />
    <div className="aps-questionnaire-identity-photo-select-content">
      <div className="uk-text-center aps-questionnaire-identity-photo-select">
        <span
          uk-icon="icon: plus-circle; ratio: 1.5;"
          className="uk-icon"
        />
        <p>
          Ajouter une photo <br /> d’identité
        </p>
      </div>
    </div>
  </div>)
}
const Content = ({image}) => {
  return (
    <div
    className="aps-questionnaire-identity-photo-container uk-form-custom aps-questionnaire-identity-photo-container-uploaded"
    data-uk-form-custom
  >
    <img
      className="aps-questionnaire-identity-photo-picker aps-questionnaire-identity-uploaded"
      src={image}
      alt="avatar"
    />
    <div className="aps-questionnaire-identity-photo-select-content aps-questionnaire-content-uploaded">
      <div className="uk-text-center aps-questionnaire-identity-photo-select">
        <span
          uk-icon="icon: plus-circle; ratio: 1.5;"
          className="uk-icon"
        />
        <p>
          Ajouter une photo <br /> d’identité
        </p>
      </div>
    </div>
  </div>
  )
}
const Loading = () => {
  return (
    <div className="aps-questionnaire-spinner-component-loading">
      <div className="uk-spinner">
        <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 30 30" ratio="1">
           <circle fill="none" stroke="#AEC340" cx="15" cy="15" r="8"></circle>
        </svg>
      </div>
      <div className="aps-section-register-desc">chargement en cours</div>
    </div>
  )
}
export default AvatarBox;



// WEBPACK FOOTER //
// ./src/components/Questionnaire/AvatarBox.js